import { Link } from "react-router-dom";
import ScrollReveal from "../../../components/feature/ScrollReveal";
import { useHomeData } from "../../../lib/useMockData";

export default function YokohamaFeature() {
  const { yokohamaFeature } = useHomeData();
  return (
    <section className="py-20 md:py-28 bg-airdoa-cream">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <ScrollReveal direction="up">
              <div>
                <p className="section-label mb-3">{yokohamaFeature.label}</p>
                <h2 className="section-title">{yokohamaFeature.title}</h2>
                <p className="mt-5 text-base text-airdoa-gray leading-[1.9]">
                  {yokohamaFeature.subtitle}
                </p>

                <div className="mt-8 flex flex-wrap gap-8">
                  {yokohamaFeature.stats.map((stat) => (
                    <div key={stat.label}>
                      <p className="text-2xl md:text-3xl font-serif font-semibold text-airdoa-navy">
                        {stat.value}
                      </p>
                      <p className="text-xs text-airdoa-gray mt-1">{stat.label}</p>
                    </div>
                  ))}
                </div>

                <Link to={yokohamaFeature.cta.href} className="btn-primary mt-10 inline-flex">
                  {yokohamaFeature.cta.label}
                </Link>
              </div>
            </ScrollReveal>

            <ScrollReveal direction="scale" delay={200}>
              <div className="relative overflow-hidden rounded-lg">
                <img
                  src={yokohamaFeature.image}
                  alt="横浜ヘリクルージング"
                  className="w-full h-80 md:h-[28rem] object-cover object-top transition-transform duration-700 hover:scale-105"
                />
              </div>
            </ScrollReveal>
          </div>
        </div>
      </div>
    </section>
  );
}